// sentry dep for monitoring and repport error
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import store from './engine/store'
import './global.css'
import * as serviceWorker from './serviceWorker'

Sentry.init({
    dsn: 'https://8e380e16564f4cc390d5e76d94f72300@o413777.ingest.sentry.io/5301821',
    environment: window.location.hostname
        ? window.location.hostname
        : 'inconnu',
})

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)

serviceWorker.unregister()
